module.exports = __webpack_public_path__ + "static/media/12304457_979646718743579_6381994561719372921_o.bfba6d08.jpg";